import React, { useState, useEffect } from 'react';
import { Layout, Row, Col, Image, Badge, Menu, Dropdown, Button, notification } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { collection, query, where, onSnapshot, updateDoc, doc } from 'firebase/firestore';
import { sendData } from '../../httpRequests';
import { db } from '../../firebase';
import { getPharmacyId } from '../Shared';

import './TopBar.css';

const { Header } = Layout;

const gridCentered = {
	alignItems: 'center',
	justifyContent: 'flex-start',
	display: 'grid'
};

export default function TopBar() {
	const navigate = useNavigate();

	const [notifications, setNotifications] = useState([]);
	const [pharmacy, setPharmacy] = useState({});

	useEffect(() => {
		notification.destroy();
		const pharmacyId = getPharmacyId();
		if (pharmacyId) {
			getNotifications(pharmacyId);
			getNotificationsByAdmin(pharmacyId);

			const url = '/pharmacies/getPharmacyById';
			const data = {
				id: pharmacyId
			};
			sendData(url, data).then((response) => {
				const pharmacy = response['pharmacy'];
				setPharmacy(pharmacy);
			});
		}
		// NuevaPrueba(pharmacyId)
	}, []);

	

	const getNotifications = (pharmacyId) => {
		let initState = true;

		const q = query(collection(db, 'notifications'), where('user_id', '==', pharmacyId));
		onSnapshot(q, (querySnapshot) => {
			if (initState) initState = false;
			else {
				if (!querySnapshot.docChanges().length == 0) {
					querySnapshot.docChanges().forEach((change) => {
						if (change.type === 'added') {
							const notification = change.doc.data();
							notification.id = change.doc.id;
							openNotification(notification);
						}
					});
				}
			}

			const notifications = [];
			querySnapshot.forEach((doc) => {

				const notification = doc.data();
				if (notification.order_status == 1 && notification.seen == false) {
					notification.id = doc.id;
					notifications.push(notification);
				}
			});
			setNotifications(notifications);
			
		});
	};

	const getNotificationsByAdmin = () => {
		let initState = true;

		const q = query(collection(db, 'notifications'));
		onSnapshot(q, (querySnapshot) => {
			if (initState) initState = false;
			else {
				if (!querySnapshot.docChanges().length == 0) {
					querySnapshot.docChanges().forEach((change) => {
						if (change.type === 'added') {
							const notification = change.doc.data();
							notification.id = change.doc.id;
							openNotification(notification);
						}
					});
				}
			}

			const notifications = [];
			querySnapshot.forEach((doc) => {

				const notification = doc.data();
				if (notification.order_status == 1 && notification.seen == false) {
					notification.id = doc.id;
					notifications.push(notification);
				}
			});
			setNotifications(notifications);
			
		});
	};

	const openNotification = (notificationData) => {
		const key = `open${Date.now()}`;
		const btn = (
			<Button
				type='primary'
				style={{ backgroundColor: '#128780', borderRadius: 10, height: 35, width: 100 }}
				size='small'
				onClick={() => {
					notification.close(key);
					checkNotification(notificationData);
				}}
			>
				Open order
			</Button>
		);
		notification.open({
			message: notificationData.message,
			btn,
			key,
			duration: 0
		});
	};

	const checkNotification = async (notification) => {
		const notificationRef = doc(db, 'notifications', notification.id);
		console.log(notification.id, "notification.id", notificationRef)
		await updateDoc(notificationRef, {
			seen: true
		});

		navigate('/orderDetails/' + notification.order_id);

		const path = window.location.pathname;
		if (path.includes('orderDetails')) {
			window.location.reload();
		}
	};

	const menu = (
		<Menu>
			{notifications.map((notification) => (
				<Menu.Item
					style={{ padding: 20 }}
					key={notification.id}
					onClick={() => {
						checkNotification(notification);
					}}
				>
					{notification.message}
				</Menu.Item>
			))}

			{Object.keys(notifications).length == 0 && (
				<Menu.Item key={0} style={{ padding: 20 }}>
					No orders have been placed recently.
				</Menu.Item>
			)}
		</Menu>
	);

	return (
		<Header className='top-header'>
			{Object.keys(pharmacy).length > 0 && (
				<Row gutter={24} style={{ width: '100%', height: '100%', alignItems: 'center' }}>
					<Col span={24}>
						<Row gutter={24} style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
							<Col span={2} style={gridCentered}>
								<Image
									src={
										pharmacy.img != null
											? pharmacy.img
											: require('../../assets/images/profile_avatar.png')
									}
									height={45}
									width={45}
									wrapperStyle={{ borderRadius: 40 }}
									style={{ borderRadius: 40 }}
								/>
							</Col>
							<Col span={7} style={gridCentered}>
								<h3>{pharmacy.name}</h3>
							</Col>
							<Col span={7} style={gridCentered}>
								<h3>Code: {pharmacy.security_code}</h3>
							</Col>
							<Col span={7} style={gridCentered}>
								<h3>Secret key: {pharmacy.secret_key}</h3>
							</Col>
							<Col span={1} style={gridCentered}>
								<Badge count={Object.keys(notifications).length} color={'#128780'}>
									<Dropdown overlay={menu} trigger={['click']} placement='bottomLeft'>
										<BellOutlined onClick={(e) => e.preventDefault()} />
									</Dropdown>
								</Badge>
							</Col>
						</Row>
					</Col>
				</Row>
			)}
		</Header>
	);
}
